export default __webpack_public_path__ + "static/security-8ab33172774f40bf8f6d9822face01b9.png";